/*       */

import { gql } from '@apollo/client';

export default gql`
    query translationRuleQuery($filterBy: [JSON], $groupBy: [JSON], $orderBy: [JSON]) {
        result: select(entity: "customEntity", filterBy: $filterBy, groupBy: $groupBy, orderBy: $orderBy)
    }
`;
